import type { GalleryType, IconName, Role, ToolCategory } from '@/types';

/** Icon shown beside a tool's category chip. */
export const CATEGORY_ICON: Record<ToolCategory, IconName> = {
  كتابة: 'edit',
  تصميم: 'grid_view',
  عروض: 'dashboard',
  صوت: 'volume',
  فيديو: 'video',
  موارد: 'description',
  اختبارات: 'check_box',
  تسجيل: 'schedule',
  مواقع: 'language',
  تعاون: 'done_all',
  ملاحظات: 'receipt_long',
  برمجة: 'code',
  رسمي: 'account_balance',
};

export const GALLERY_TYPES: readonly GalleryType[] = [
  'صورة تعليمية',
  'فيديو',
  'رابط تعليمي',
  'مثال عملي',
] as const;

/** Placeholder icon used when a gallery entry has no thumbnail. */
export const GALLERY_TYPE_ICON: Record<GalleryType, IconName> = {
  'صورة تعليمية': 'grid_view',
  فيديو: 'video',
  'رابط تعليمي': 'language',
  'مثال عملي': 'check_box',
};

export const ROLES: readonly Role[] = ['معلم', 'معلمة', 'طالب', 'طالبة'] as const;

/** Teachers read green, students read red — mirrors the brand's two accents. */
export const ROLE_TONE: Record<Role, 'brand' | 'accent'> = {
  معلم: 'brand',
  معلمة: 'brand',
  طالب: 'accent',
  طالبة: 'accent',
};

/** Sentinel for the "all" option in every filter row. */
export const ALL_FILTER = 'الكل';
